import React, { useState } from "react";
import { Box } from "@chakra-ui/react";
import {
  customEvent,
  getCdnImageSrc,
  Image,
  // kakaoPixel,
  // tossPixel,
  // pixelCustomEvent,
  // PixelEventName,
} from "goi_common";
// import { naverConversionEvent } from "@/utils/naverPageView";
import { BaseButton } from "goi_common/src/design-system/components/BaseButton";
import { BaseStack } from "goi_common/src/design-system";
import TutorialCarousel from "goi_common/src/design-system/composites/TutorialCarousel";

interface PromotionTutorialContainerProps {
  images: string[];
  onNextComplete?: () => void;
  isNextCompleteDisabled?: boolean;
}

export default function PromotionTutorialContainer({
  images,
  onNextComplete,
  isNextCompleteDisabled = false,
}: PromotionTutorialContainerProps) {
  const [currentIndex, setCurrentIndex] = useState(0);
  const isFirstSlide = currentIndex === 0;

  const handlePrev = () => {
    if (currentIndex > 0) {
      customEvent({
        newGtm: {
          path: "home",
          trigger_and_target: `btn_prev_${currentIndex + 1}` as any,
        },
      });
      customEvent({
        newGtm: {
          path: "promotion",
          trigger_and_target: `btn_prev_${currentIndex + 1}` as any,
        },
      });
      setCurrentIndex(currentIndex - 1);
    }
  };

  const handleNext = () => {
    customEvent({
      newGtm: {
        path: "home",
        trigger_and_target: `btn_next_${currentIndex + 1}` as any,
      },
    });
    customEvent({
      newGtm: {
        path: "promotion",
        trigger_and_target: `btn_next_${currentIndex + 1}` as any,
      },
    });

    if (currentIndex < images.length - 1) {
      setCurrentIndex(currentIndex + 1);
    } else {
      // 기본 CTA 및 픽셀 이벤트 내장
      customEvent({
        newGtm: {
          path: "home",
          trigger_and_target: "CTA",
        },
      });
      customEvent({
        newGtm: {
          path: "promotion",
          trigger_and_target: "CTA",
        },
      });

      // naverConversionEvent({ type: "view_product" });
      // kakaoPixel()?.participation();
      // tossPixel()?.productView();
      // pixelCustomEvent(PixelEventName.ViewContent);

      if (onNextComplete) {
        onNextComplete();
      }
    }
  };

  return (
    <TutorialCarousel
      currentIndex={currentIndex}
      CarouselItems={images.map((src, index) => (
        <Box key={index} width="100%">
          <Image
            src={getCdnImageSrc(src)}
            width="100%"
            height="auto"
            alt={`Step ${index + 1}`}
          />
        </Box>
      ))}
      FixedButtons={
        <BaseStack direction="horizontal" width="100%" spacing="8px">
          {!isFirstSlide && (
            <Box flex={1}>
              <BaseButton
                type="assistive_1"
                size="large"
                outlined={true}
                onClick={handlePrev}
              >
                <Box className="body_16_m">이전</Box>
              </BaseButton>
            </Box>
          )}
          <Box flex={1}>
            <BaseButton
              type="primary"
              size="large"
              onClick={handleNext}
              disabled={
                isNextCompleteDisabled && currentIndex === images.length - 1
              }
            >
              <Box className="body_16_m">다음</Box>
            </BaseButton>
          </Box>
        </BaseStack>
      }
    />
  );
}
